import { render, staticRenderFns } from "./OtherServicesList.vue?vue&type=template&id=5c03724c&"
import script from "./OtherServicesList.vue?vue&type=script&lang=js&"
export * from "./OtherServicesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports